import { Routes } from '@angular/router'
import { RegistrationComponent } from './app/registration/registration.component';
import { LoginComponent } from './app/registration/login/login.component';
import { SignupComponent } from './app/registration/signup/signup.component';
import { UltilitiesComponent } from './app/ultilities/ultilities.component';
import { RolesGridComponent } from './app/ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './app/ultilities/roles/roles-form/roles-form.component';
import { UserGridComponent } from './app/ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './app/ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './app/ultilities/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './app/ultilities/claims/claim-form/claim-form.component';
import { AuthGuard } from './app/auth/auth.guard';
import { ChangePasswordComponent } from './app/ultilities/change-password/change-password.component';
import { ForgotPasswordComponent } from './app/registration/forgot-password/forgot-password.component';
import { HomepageComponent } from './app/homepage/homepage.component';
import { LeadComponent } from './app/Pages/lead/lead.component';
import { LeadGridComponent } from './app/Pages/Lead/lead-grid/lead-grid.component';
import { LeadFormComponent } from './app/Pages/Lead/lead-form/lead-form.component';
import { ActivityFormComponent } from './app/Pages/activities/activity-form/activity-form.component';
import { ActivityGridComponent } from './app/Pages/activities/activity-grid/activity-grid.component';
import { ActivitiesComponent } from './app/Pages/activities/activities.component';
import { ReportsComponent } from './app/Pages/reports/reports.component';
import { ReportGridComponent } from './app/Pages/reports/report-grid/report-grid.component';
import { ReportFormComponent } from './app/Pages/reports/report-form/report-form.component';
import { SalesOrdersComponent } from './app/Pages/sales-orders/sales-orders.component';
import { SalesOrderGridComponent } from './app/Pages/sales-orders/sales-order-grid/sales-order-grid.component';
import { SalesOrderFormComponent } from './app/Pages/sales-orders/sales-order-form/sales-order-form.component';
import { AssignLeadGridComponent } from './app/Pages/lead/assign-leads/assign-lead-grid/assign-lead-grid.component';
import { CompanyProfileGridComponent } from './app/ultilities/company-profile/company-profile-grid/company-profile-grid.component';
import { CompanyProfileFormComponent } from './app/ultilities/company-profile/company-profile-form/company-profile-form.component';
import { DivisionDeptGridComponent } from './app/ultilities/division-department/division-dept-grid/division-dept-grid.component';
import { DivisionDeptFormComponent } from './app/ultilities/division-department/division-dept-form/division-dept-form.component';
import { EmpMasterGridComponent } from './app/ultilities/employee-master/emp-master-grid/emp-master-grid.component';
import { EmpMasterFormComponent } from './app/ultilities/employee-master/emp-master-form/emp-master-form.component';
import { ManageComponent } from './app/Pages/manage/manage.component';
import { VenderGridComponent } from './app/Pages/Manage/vender/vender-grid/vender-grid.component';
import { VenderFromComponent } from './app/Pages/manage/vender/vender-from/vender-from.component';
import { ProductGridComponent } from './app/Pages/Manage/products/product-grid/product-grid.component';
import { ProductFormComponent } from './app/Pages/Manage/products/product-form/product-form.component';
import { SalseQuotationGridComponent } from './app/Pages/sales-orders/sales-quotation/salse-quotation-grid/salse-quotation-grid.component';
import { SalseQuotationFormComponent } from './app/Pages/sales-orders/sales-quotation/salse-quotation-form/salse-quotation-form.component';
import { PerformaInvoiceGridComponent } from './app/Pages/sales-orders/performa-invoice/performa-invoice-grid/performa-invoice-grid.component';
import { PerformaInvoiceFormComponent } from './app/Pages/sales-orders/performa-invoice/performa-invoice-form/performa-invoice-form.component';
import { SalesDeliveryChallanGridComponent } from './app/Pages/sales-orders/sales-delivery-challan/sales-delivery-challan-grid/sales-delivery-challan-grid.component';
import { SalesDeliveryChallanFormComponent } from './app/Pages/sales-orders/sales-delivery-challan/sales-delivery-challan-form/sales-delivery-challan-form.component';
import { TaxInvoiceGridComponent } from './app/Pages/sales-orders/tax-invoice/tax-invoice-grid/tax-invoice-grid.component';
import { TaxInvoiceFormComponent } from './app/Pages/sales-orders/tax-invoice/tax-invoice-form/tax-invoice-form.component';
import { TaxInvoiceRetailGridComponent } from './app/Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-grid/tax-invoice-retail-grid.component';
import { TaxInvoiceRetailFormComponent } from './app/Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-form/tax-invoice-retail-form.component';
import { ReceiptConfirmationGridComponent } from './app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-grid/receipt-confirmation-grid.component';
import { ReceiptConfirmationFormComponent } from './app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-form/receipt-confirmation-form.component';
import { ArReceiptGridComponent } from './app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-grid/ar-receipt-grid.component';
import { ArReceiptFormComponent } from './app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-form/ar-receipt-form.component';
import { PurchaseComponent } from './app/Pages/purchase/purchase.component';
import { PurchaseQuotationGridComponent } from './app/Pages/purchase/purchase-quotation/purchase-quotation-grid/purchase-quotation-grid.component';
import { PurchaseQuotationFormComponent } from './app/Pages/purchase/purchase-quotation/purchase-quotation-form/purchase-quotation-form.component';
import { QuotationComparisonGridComponent } from './app/Pages/purchase/quotation-comparison/quotation-comparison-grid/quotation-comparison-grid.component';
import { QuotationComparisonFormComponent } from './app/Pages/purchase/quotation-comparison/quotation-comparison-form/quotation-comparison-form.component';
import { QuotationApprovalGridComponent } from './app/Pages/purchase/quotation-approval/quotation-approval-grid/quotation-approval-grid.component';
import { QuotationApprovalFormComponent } from './app/Pages/purchase/quotation-approval/quotation-approval-form/quotation-approval-form.component';
import { PurchaseOrderGridComponent } from './app/Pages/purchase/purchase-order/purchase-order-grid/purchase-order-grid.component';
import { PurchaseOrderFormComponent } from './app/Pages/purchase/purchase-order/purchase-order-form/purchase-order-form.component';
import { QdChallanGridComponent } from './app/Pages/purchase/quotation-delivery-challan/qd-challan-grid/qd-challan-grid.component';
import { QdChallanFormComponent } from './app/Pages/purchase/quotation-delivery-challan/qd-challan-form/qd-challan-form.component';
import { MrNoteGridComponent } from './app/Pages/purchase/material-receipt-note/mr-note-grid/mr-note-grid.component';
import { MrNoteFormComponent } from './app/Pages/purchase/material-receipt-note/mr-note-form/mr-note-form.component';
import { MrnApprovalGridComponent } from './app/Pages/purchase/mrn-approval/mrn-approval-grid/mrn-approval-grid.component';
import { MrnApprovalFormComponent } from './app/Pages/purchase/mrn-approval/mrn-approval-form/mrn-approval-form.component';
import { ArPaymentGridComponent } from './app/Pages/purchase/account-receivable-payment/ar-payment-grid/ar-payment-grid.component';
import { ArPaymentFormComponent } from './app/Pages/purchase/account-receivable-payment/ar-payment-form/ar-payment-form.component';
import { PaymentApprovalGridComponent } from './app/Pages/purchase/payment-approval/payment-approval-grid/payment-approval-grid.component';
import { PaymentApprovalFormComponent } from './app/Pages/purchase/payment-approval/payment-approval-form/payment-approval-form.component';
import { ProductViewComponent } from './app/pages/manage/products/product-view/product-view.component';
import { ProfileComponent } from './app/Pages/user/profile/profile.component';
import { FeedbackComponent } from './app/Pages/User/feedback/feedback.component';
import { ArReceiptViewComponent } from './app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-view/ar-receipt-view.component';

export const appRoutes: Routes = [
    {
        path: 'home', component: HomepageComponent, canActivate: [AuthGuard],
        children: [
            {
                path: 'password', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },
            {
                path: 'password/:userId', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },
            {
                path: 'rolesgrid', component: UltilitiesComponent,
                children: [{ path: '', component: RolesGridComponent },
                { path: 'rolesform', component: RolesFormComponent },
                { path: 'rolesform/:roleId/:mode', component: RolesFormComponent }
                ]
            },
            {
                path: 'user', component: UltilitiesComponent,
                children: [{ path: '', component: UserGridComponent },
                { path: 'userform', component: UserFormComponent },
                { path: 'userform/:Id/:mode', component: UserFormComponent }
                ]
            },
            // {
            //     path: 'claims', component: UltilitiesComponent,
            //     children: [{ path: '', component: ClaimGridComponent },            
            //     { path: 'claimform', component: ClaimFormComponent },
            //     { path: 'claimform/:roleId/:roleName', component: ClaimFormComponent }
            //     ]
            // },
            {
                path: 'claims', component: UltilitiesComponent,
                children: [{ path: '', component: ClaimGridComponent },
                { path: 'claimform/:roleId/:roleName', component: ClaimFormComponent }
                ]
            },
            {
                path: 'company-profile', component: UltilitiesComponent,
                children: [
                    { path: '', component: CompanyProfileGridComponent },
                    { path: 'company-profile-form', component: CompanyProfileFormComponent },
                    { path: 'company-profile-form/:Company_Id/:mode', component: CompanyProfileFormComponent }
                ]
            },
            {
                path: 'division-department', component: UltilitiesComponent,
                children: [
                    { path: '', component: DivisionDeptGridComponent },
                    { path: 'division-department-form', component: DivisionDeptFormComponent },
                    
                ]
            },
            {
                path: 'employee-master', component: UltilitiesComponent,
                children: [
                    { path: '', component: EmpMasterGridComponent },
                    { path: 'employee-master-form', component: EmpMasterFormComponent },
                    { path: 'employee-master-form/:EMP_ID/:mode', component: EmpMasterFormComponent }
                ]
            },

            //Routing - Start   
            // User
            { path: 'profile', component: ProfileComponent },
            { path: 'feedback', component: FeedbackComponent },
            //Manage
            {
                path: 'manage', component: ManageComponent,
                children: [
                    { path: '', component: VenderGridComponent },
                    { path: 'vendor-form', component: VenderFromComponent },
                    { path: 'vendor-form/:DOC_NOs/:mode', component: VenderFromComponent }
                  //  {path:'PigmyAgent/add/:AGENT_ID/:mode',component:VenderFromComponent}      
                ]
            },
            {
                path: 'products', component: ManageComponent,
                children: [
                    { path: '', component: ProductGridComponent },
                    { path: 'product-form', component: ProductFormComponent },
                   // { path: 'product-view', component: ProductViewComponent }
                    { path: 'product-form/:DOC_NOs/:mode', component: ProductFormComponent }
                ]
            },
            {
                path: 'lead', component: LeadComponent,
                children: [
                    { path: '', component: LeadGridComponent },
                    { path: 'lead-form', component: LeadFormComponent },
                    { path: 'lead-form/:DOC_NOs/:mode', component: LeadFormComponent }
                ]
            },
            {
                path: 'assign-lead', component: LeadComponent,
                children: [
                    { path: '', component: AssignLeadGridComponent },
                ]
            },
            {
                path: 'activity', component: ActivitiesComponent,
                children: [
                    { path: '', component: ActivityGridComponent },
                    { path: 'activity-form', component: ActivityFormComponent },
                    { path: 'activity-form/:DOC_NOs/:mode', component: ActivityFormComponent }
                ]
            },
            {
                path: 'report', component: ReportsComponent,
                children: [
                    { path: '', component: ReportGridComponent },
                    { path: 'report-form', component: ReportFormComponent }
                ]
            },           
            {
                path: 'sales-order', component: SalesOrdersComponent,
                children: [
                    { path: '', component: SalesOrderGridComponent },
                    { path: 'sales-order-form', component: SalesOrderFormComponent }
                ]
            },
            {
                path: 'quoatation', component: SalesOrdersComponent,
                children: [
                    { path: '', component: SalseQuotationGridComponent },
                    { path: 'quoatation-form', component: SalseQuotationFormComponent }
                ]
            },
            {
                path: 'performa-invoice', component: SalesOrdersComponent,
                children: [
                    { path: '', component: PerformaInvoiceGridComponent },
                    { path: 'performa-invoice-form', component: PerformaInvoiceFormComponent }
                ]
            },
            {
                path: 'delivery-challan', component: SalesOrdersComponent,
                children: [
                    { path: '', component: SalesDeliveryChallanGridComponent },
                    { path: 'delivery-challan-form', component: SalesDeliveryChallanFormComponent }
                ]
            },
            {
                path: 'tax-invoice', component: SalesOrdersComponent,
                children: [
                    { path: '', component: TaxInvoiceGridComponent },
                    { path: 'tax-invoice-form', component: TaxInvoiceFormComponent }
                ]
            },
            {
                path: 'tax-invoice-retail', component: SalesOrdersComponent,
                children: [
                    { path: '', component: TaxInvoiceRetailGridComponent },
                    { path: 'tax-invoice-retail-form', component: TaxInvoiceRetailFormComponent }
                ]
            },
            {
                path: 'accounts-receivable-receipt', component: SalesOrdersComponent,
                children: [
                    { path: '', component: ArReceiptGridComponent },
                    { path: 'accounts-receivable-receipt-form', component: ArReceiptFormComponent },
                    { path: 'accounts-receivable-receipt-view', component: ArReceiptViewComponent }
                ]
            },
            {
                path: 'receipt-confirmation', component: SalesOrdersComponent,
                children: [
                    { path: '', component: ReceiptConfirmationGridComponent },
                    { path: 'receipt-confirmation-form', component: ReceiptConfirmationFormComponent }
                ]
            },
            //purchase
            {
                path: 'purchase', component: PurchaseComponent,
                children: [
                    { path: '', component: PurchaseQuotationGridComponent },
                    { path: 'purchase-quotation-form', component: PurchaseQuotationFormComponent }
                ]
            },
            {
                path: 'quatation-comparison', component: PurchaseComponent,
                children: [
                    { path: '', component: QuotationComparisonGridComponent },
                    { path: 'quatation-comparison-form', component: QuotationComparisonFormComponent }
                ]
            },
            {
                path: 'quotation-approval', component: PurchaseComponent,
                children: [
                    { path: '', component: QuotationApprovalGridComponent },
                    { path: 'quotation-approval-form', component: QuotationApprovalFormComponent }
                ]
            },
            {
                path: 'purchase-order', component: PurchaseComponent,
                children: [
                    { path: '', component: PurchaseOrderGridComponent },
                    { path: 'purchase-order-form', component: PurchaseOrderFormComponent }
                ]
            },
            {
                path: 'QuotationDeliveryChallan', component: PurchaseComponent,
                children: [
                    { path: '', component: QdChallanGridComponent },
                    { path: 'QuotationDeliveryChallan-form', component: QdChallanFormComponent }
                ]
            },
            {
                path: 'material-receipt-note', component: PurchaseComponent,
                children: [
                    { path: '', component: MrNoteGridComponent },
                    { path: 'material-receipt-note-form', component: MrNoteFormComponent }
                ]
            },
            {
                path: 'mrn-approval', component: PurchaseComponent,
                children: [
                    { path: '', component: MrnApprovalGridComponent },
                    { path: 'mrn-approval-form', component: MrnApprovalFormComponent }
                ]
            },
            {
                path: 'accounts-receivable-payment', component: PurchaseComponent,
                children: [
                    { path: '', component: ArPaymentGridComponent },
                    { path: 'accounts-receivable-payment-form', component: ArPaymentFormComponent }
                ]
            },
            {
                path: 'payment-approval', component: PurchaseComponent,
                children: [
                    { path: '', component: PaymentApprovalGridComponent },
                    { path: 'payment-approval-form', component: PaymentApprovalFormComponent }
                ]
            }           
        ],

    },
    {
        path: 'login', component: RegistrationComponent,
        children: [{ path: '', component: LoginComponent }]
    },

    {
        path: 'signup', component: RegistrationComponent,
        children: [{ path: '', component: SignupComponent }]
    },

    {
        path: 'forgot-password', component: RegistrationComponent,
        children: [{ path: '', component: ForgotPasswordComponent }]
    },
    { path: '', redirectTo: '/login', pathMatch: 'full' },

];


// WEBPACK FOOTER //
// ./src/route.ts